import React from 'react'
import { createStyles, withStyles } from '@material-ui/core'

import PageLink, { textStyles } from '../PageLink'
import Item from './Item'

const styles = () => {
  return createStyles({
    text: {
      ...textStyles,
      color: 'rgba(0, 0, 0, 0.8)',
      fontWeight: 400,
      fontSize: '1rem',
    },
  })
}

const FooterLink = withStyles(styles)(PageLink)

const PageLinkItem = (props) => (
  <Item>
    <FooterLink {...props} />
  </Item>
)

export default PageLinkItem
